import * as React from 'react';
import { convertIcon } from '../components/Icon';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21 8.04-7.68 4.37c-.69.36-1.52.36-2.21 0L3 7.8V18h18V8.04ZM4.3 6l7.91 4.5L20.14 6H4.29ZM1 6c0-1.1.9-2 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6Z",
    fill: "currentColor"
  }));
}
const IconComponent = convertIcon(SvgComponent, 'mail_stroked_1');
export default IconComponent;